import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "el-dropdown-link" }
const _hoisted_2 = { id: "topnav_user_name" }

import store from "@/store";
import { computed, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserInfoDropdown',
  setup(__props) {

const router = useRouter();

// 个人信息部分
const userInfo = computed(() => store.getters["auth/managerInfo"]);

const navigateTo = (name: string) => {
  router.push({ name: name, query: { userId: userInfo.value.id } });
};

const login = () => {
  router.push({ name: "login" });
};
const logout = () => {
  store.commit("auth/clearToken");
  router.push({ name: "login" });
};

const state = reactive({
  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
});
const { circleUrl } = toRefs(state);

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (userInfo.value)
    ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, { class: "user_menu" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo('managerAccount')))
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" 账号管理 ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, {
                divided: "",
                onClick: logout
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("r.logout")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(userInfo.value.name), 1),
            _createVNode(_component_el_avatar, {
              size: 40,
              src: _unref(circleUrl)
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "user_login",
        onClick: login
      }, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("r.login")), 1)
      ]))
}
}

})